import { defineMessages } from 'react-intl'

export const deviceListMessages = defineMessages({
  title: {
    id: 'deviceListMessages.title',
    description: 'Delete device modal title',
    defaultMessage: 'Delete Device',
  },
  deleteQuestion: {
    id: 'deviceListMessages.deleteQuestion',
    description: 'Are  you sure message',
    defaultMessage: 'Are you sure you want to delete device: ',
  },
  confirmMessage: {
    id: 'deviceListMessages.confirmMessage',
    description: 'Confirm button text',
    defaultMessage: 'Yes, Delete',
  },
})
